import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { format } from "date-fns";
import {  useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { postdatas } from "../../../apis/apiService";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import { BtnLoader } from "../../common/Loader";
export const MilestoneTaskExport = ({ onClear, onCancel, MilestoneTasklist }) => {
  const project_id = localStorage.getItem("project_id");


  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Tasks: "",
      StartDate: null,
      EndDate: null,
    },
  });

  const handleApply = handleSubmit((data) => {
    onSubmit(data);
  });

  const onSubmit = async (data) => {
    //console.log("owner_data :", data);
    const requestedData = {
      task_list_id: data.Tasks,
      project_id: project_id,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
    };
    setLoading(true);

    try {
      const response = await postdatas("tasklist", "export", requestedData);
      if (response && response.data) {
        const downloadUrl = response.data.replace(/\\/g, "/");
        onCancel();
        // Create a temporary link to trigger the download
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = downloadUrl.split('/').pop(); // Extract filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
       else {
        throw new Error("The response does not contain a valid download URL.");
      }

      toast.success("Export successful.");
    }
     catch (error) {
      console.error("Error filtering tasks:", error.message);
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };
  
  const formattedTaskOptions = MilestoneTasklist?.map((item) => ({
    title: item.task_list_name,
    task_id: item.task_list_id,
  })) || [];
  const handleClear = () => {
    reset(); // Reset the form to default values
    onClear?.(); // Trigger any additional clear action if provided
  };

  return (
    <div>
      {/* Header Section */}
      <div className="d-flex align-items-center bg-white justify-content-between px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Export Milestone
          </div>
        </button>
        <div>

          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Filter Form */}
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <>
              <div className="g-3  mb-2 row">
                <div className="col-md-12  mb-2 ">
                  <label htmlFor="Tasks" className="form-label gap-2 d-flex">
                    Task List
                    <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="Tasks"
                    control={control}
                    rules={{
                      required: "Task List is required",
                    }}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        id="Tasks"
                        options={formattedTaskOptions}
                        getOptionLabel={(option) => option.title || ""}
                        isOptionEqualToValue={(option, val) =>
                          option.task_id === val.task_id
                        }
                        value={
                          value
                            ? formattedTaskOptions.find(
                                (opt) => opt.task_id === value
                              ) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          onChange(newValue ? newValue.task_id : "");
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select task list" />
                        )}
                      />
                    )}
                  />
                  {errors.Tasks && (
                    <span className="errorMsg">{errors.Tasks.message}</span>
                  )}
                </div>

                {/* Row 2 */}
                <div className="col-md-6">
                  <label htmlFor="StartDate"className="form-label gap-2 d-flex">
                    Start date<span className="errorMsg">*</span>
                  </label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="StartDate"
                      rules={{ required: "Start date is required" }}
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                    {errors.StartDate && (
                      <span className="errorMsg">
                        {errors.StartDate.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="EndDate"className="form-label gap-2 d-flex">End date  <span className="errorMsg">*</span></label>
                 
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      control={control}
                      name="EndDate"
                      rules={{ required: "End date is required" }}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          onChange={(date) => field.onChange(date)}
                          format="DD/MM/YYYY"
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                    {errors.EndDate && (
                      <span className="errorMsg">{errors.EndDate.message}</span>
                    )}
                  </div>
                </div>
               
              </div>
            </>
            {/* Footer Buttons */}
            <div className="d-flex bg-white position-absolute w-100 bottom-0 mt-5 py-3">
              <button
                type="button"
                className="add_btn me-3"
                disabled={loading}
                onClick={handleApply}
              >
                {loading ? <BtnLoader /> : "Apply"}
              </button>

              <button
                type="button"
                className="cancel_btn"
                disabled={loading}
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
